'use client';

import { cn, Flex } from '@zoomit/primitives';

import NotificationBody from './NotificationBody';

type Props = {
  onClose: () => void;
  className?: string;
};

const MobileNotification = (props: Props) => {
  const { onClose } = props;
  return (
    <Flex
      spacing={{ pt: 'x3' }}
      flexDirection="column"
      justifyContent="space-between"
      flexWrap="nowrap"
      className={cn('scroll-smooth', props.className)}
    >
      <NotificationBody onClose={onClose} />
    </Flex>
  );
};

export default MobileNotification;
